import { Component, OnInit } from '@angular/core';
import { CommonService } from '../services/common.service';

@Component({
  selector: 'app-carga',
  templateUrl: './carga.component.html',
  styleUrls: ['./carga.component.scss'],
  providers: [CommonService]
})
export class CargaComponent implements OnInit {
  public zonas:any[];
  public barrios:any[];
  public barrio:any;

  constructor(private commonService:CommonService) { }

  ngOnInit() {
    this.barrio = {
      zonas_id: 0,
      nombre: ''
    };

    Promise.all([
      this.commonService.getZonas(),
      this.commonService.getBarrios()
    ]).then(result => { 
      this.zonas = result[0];
      this.barrios = result[1];
    });
  }

  public getNombreZona(idZona):string {
    let result = '';

    this.zonas.forEach(zona => {
      if (zona.id === idZona) {
        result = zona.nombre;
      }
    });

    return result;
  }

  public saveBarrio() {
    this.commonService
      .saveBarrio(this.barrio)
      .then(() => {
        this.barrio = {
          zonas_id: 0,
          nombre: ''
        };
        this.commonService.getBarrios()
          .then(result => this.barrios = result);
    });
  }

}



// WEBPACK FOOTER //
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/app/carga/carga.component.ts